export { default as default } from '../modules/PhoneInputWithCountry.js'
export { default as formatPhoneNumber, formatPhoneNumberIntl } from '../modules/libphonenumber/formatPhoneNumber.js'

export {
	default as parsePhoneNumber,
	isValidPhoneNumber,
	isPossiblePhoneNumber,
	getCountryCallingCode,
	getCountries,
	isSupportedCountry
} from 'libphonenumber-js/core'


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-phone-number-input/core/index.js
// module id = 6Kk6
// module chunks = 0